import {ArrowBack} from '@mui/icons-material';
import {Box, IconButton, Typography} from '@mui/material';
import {FC, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {useNavigate} from 'react-router-dom';
import AMPModal from 'src/components/common/AMPModal';
import {FeedbackForm} from 'src/components/forms/FeedbackForm';
import {LogoBlack} from 'src/components/icons/LogoBlack';
import {MailIcon} from 'src/components/icons/MailIcon';
import {AppRouteEnum, AppRouteSpace} from 'src/utils/helper';
import {backButtonSx, innerSx, modalButtonSx, wrapperSx} from './CorporateUserWelcome.sx';
import {FeedbackTypeEnum} from '../../types';

export const CorporateUserWelcome: FC = () => {
    const navigate = useNavigate();
    const navigateToLogin = () => {
        navigate(AppRouteSpace([AppRouteEnum.login]));
    };

    const [open, setOpen] = useState<boolean>(false);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const intl = useIntl();
    const dialogTitle = intl.formatMessage({id: 'feedback'});

    return (
        <Box sx={wrapperSx}>
            <IconButton
                sx={backButtonSx}
                onClick={navigateToLogin}
            >
                <ArrowBack/>
            </IconButton>
            <LogoBlack/>
            <Box sx={innerSx}>
                <Typography variant="body1">
                    <FormattedMessage id="welcomeCorporateUserMessage"/>
                </Typography>
            </Box>
            <IconButton
                onClick={handleOpen}
                sx={modalButtonSx}
            >
                <MailIcon/>
            </IconButton>
            <AMPModal
                handleClose={handleClose}
                open={open}
                title={dialogTitle}
                type="xs"
                fullWidth
            >
                <FeedbackForm
                    type={FeedbackTypeEnum.HELP}
                    handleClose={handleClose}
                />
            </AMPModal>
        </Box>
    );
};
